<template>
  <div id="app" v-if="isRouterAlive">
    <Nav></Nav>
    <!--    面包屑-->
    <!--    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>-->

    <router-view :key="$route.fullPath"></router-view>


    <!-- footer -->
    <footer2></footer2>
    <!-- end -->
  </div>
</template>

<script>

import Nav from "@/components/nav.vue";
import Breadcrumb from "@/components/breadcrumb.vue";
import footer2 from "@/components/footer.vue";
import {countNum} from "@/api/clickNum";
import {getIpInfo} from "./api/ip";

export default {
  name: "App",
  components: {
    footer2,
    Breadcrumb, Nav
  },
  provide() {
    return {
      reloadApp: this.reloadApp
    }
  },
  created() {
    if (localStorage.getItem('lang') == null) {
      if (navigator.language == 'zh-CN' || navigator.language == 'zh-TW' || navigator.language == 'zh-HK') {
        this.$i18n.locale = 'zh-CN'
      }else if (navigator.language == 'en-US') {
        this.$i18n.locale = 'en-US'
      }

      // location.reload();
    }
    getIpInfo().then(res => {
      res.webName = '公司官网'
      countNum(res)
    })

  },
  data() {
    return {
      isRouterAlive: true,
      breadcrumb: [
        {name: '首页', hrefUrl: '#'},
      ],
    }
  },
  methods: {
    reloadApp() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  mounted() {
    document.querySelector('html').setAttribute('style', 'font-size: 16px')
    document.querySelector('body').setAttribute('style', 'background-color: #f2f2f2')
  },
  updated() {
  }

};
</script>

<style>

* {
  font-family: "Microsoft YaHei", SourceHanSansCN;
}

body {
  margin: 0;
  overflow-x: hidden;
  font-family: SourceHanSansCN, "Microsoft YaHei";
}

.box-shadow {
  box-shadow: 0px 0px 70px rgba(157, 179, 208, 0.4);
}
</style>
